module.exports = __webpack_public_path__ + "img/pic10@2x.d578739d.png";